import {useRef} from 'react';

import {
  processEventDateTime,
  calculateDistanceDisplay,
  processVenueInfo,
  processPricingLogic,
  generateMicroDataMarkup,
} from '../utils/eventHelpers';

export const useEventItemLogic = (
  event,
  eventItemDisplayOptions,
  showDistance,
  globalRegistry,
  type,
  userCountryCode,
  isPriceIncludeFees,
  hideTicketBisPrice = false
) => {
  const mainNodeRef = useRef(null);

  const {disablePrice} = eventItemDisplayOptions;

  const {eventDate, timeDisplay} = processEventDateTime(event, userCountryCode);
  const distanceDisplay = calculateDistanceDisplay(event, showDistance);
  const {venueDisplay} = processVenueInfo(event, distanceDisplay);
  const {totalTickets, ticketCurrencyCode, price, isSeePrices, webTLD} = processPricingLogic(
    event,
    isPriceIncludeFees,
    hideTicketBisPrice,
    globalRegistry
  );
  const {microDataToggle, microDataMarkup, jsonld} = generateMicroDataMarkup(globalRegistry, event, webTLD);

  const showPriceInfo = !disablePrice && type === 'default' && totalTickets > 0;

  const navigateTo = (e) => {
    e?.stopPropagation();
    e?.preventDefault();
    const links = mainNodeRef.current?.getElementsByClassName('EventItem__TitleLink');
    if (links?.[0]) {
      links[0].click();
    }
  };

  const handleTitleClick = (e) => {
    e?.stopPropagation();
  };

  return {
    mainNodeRef,
    navigateTo,
    handleTitleClick,
    eventData: {
      eventDate,
      timeDisplay,
      venueDisplay,
    },
    pricingData: {
      totalTickets,
      ticketCurrencyCode,
      price,
      isSeePrices,
      showPriceInfo,
    },
    microData: {
      microDataToggle,
      microDataMarkup,
      jsonld,
    },
  };
};
